import flowApp from './reducers/index';
import {applyMiddleware, createStore, compose} from "redux";
import thunk from 'redux-thunk';
// import {apiMiddleware} from "redux-api-middleware";
// import { bootRefresh } from './actions/autorefresh';
import createSagaMiddleware from 'redux-saga';
import mySaga from './sagas';
import {bootUser} from "./actions/user";
import * as Sentry from "@sentry/react";

const sentryEnhancer = Sentry.createReduxEnhancer();

const sagaMiddleware = createSagaMiddleware({onError: (e) => {
  console.error(e);
}});

const enhancers = compose(
  applyMiddleware(
    // apiMiddleware,
    sagaMiddleware,
    thunk,
  ),
  sentryEnhancer,
  window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
);

let store = createStore(
  flowApp,
  enhancers
);

sagaMiddleware.run(mySaga);


bootUser(store);



export default store;
